module.exports = __webpack_public_path__ + "img/icon-ningguang.94e350f6.webp";